import { render, staticRenderFns } from "./VvDesktopTasteTile.vue?vue&type=template&id=01adfa38&scoped=true&"
import script from "./VvDesktopTasteTile.vue?vue&type=script&lang=js&"
export * from "./VvDesktopTasteTile.vue?vue&type=script&lang=js&"
import style0 from "./VvDesktopTasteTile.vue?vue&type=style&index=0&id=01adfa38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01adfa38",
  null
  
)

export default component.exports